import type { QueryClient } from '@tanstack/react-query';
import { sqlImportDatabaseKeys, type SqlImportDatabase } from './entity';

export function setSqlImportDatabaseCache(qc: QueryClient, workspaceId: number, database: SqlImportDatabase): void {
  qc.setQueryData(sqlImportDatabaseKeys.detail(workspaceId, database.id), database);
}

/** @public */
export function getSqlImportDatabaseCache(
  qc: QueryClient,
  workspaceId: number,
  id: string,
): SqlImportDatabase | undefined {
  return qc.getQueryData<SqlImportDatabase>(sqlImportDatabaseKeys.detail(workspaceId, id));
}

export function removeSqlImportDatabaseCache(qc: QueryClient, workspaceId: number, id: string): void {
  qc.removeQueries({ queryKey: sqlImportDatabaseKeys.detail(workspaceId, id) });
}

export function invalidateSqlImportDatabaseLists(qc: QueryClient, workspaceId: number): void {
  void qc.invalidateQueries({ queryKey: sqlImportDatabaseKeys.lists(workspaceId) });
}
